<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import exeMatrixService from '@/services/embeds/plugin/exe.matrix.service'

import { useIdeStore } from '@/stores/embeds/ide.store'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'

const ideStore = useIdeStore()
const embedConfigStore = useEmbedConfigureStore()

const {
  getExeMatrixHideTitle,
  getExeMatrixTitleName,
  getExeMatrixDisplay,
  selectedLanguage,
  executionTime,
  memory,
  cpuTime,
  interActiveMode,
  isCodeExecuting
} = storeToRefs(ideStore)
const { getOnEditMode, getLanguageMeta } = storeToRefs(embedConfigStore)

const showCPUAndMemory = computed(() => {
  return isCodeExecuting.value === false && memory.value !== null && cpuTime.value !== null
})
const showExecuteDetails = computed(() => {
  return isCodeExecuting.value == false && executionTime.value !== null
})
const isCompileLanguage = computed(() => {
  if (!selectedLanguage.value || !selectedLanguage.value?.language) return false
  const languageMetaItem: any = getLanguageMeta.value[selectedLanguage.value?.language]
  return languageMetaItem.isCompile || languageMetaItem.language === 'java'
})

onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  if (getOnEditMode.value === false) {
    exeMatrixService.initExeMatrix()
    exeMatrixService.onSettingChange()
    ideStore.setExcecutionData(null)
  }
})
onBeforeUnmount(async () => {
  if (getOnEditMode.value === false) {
    exeMatrixService.destroyExeMatrix()
  }
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div class="flex h-auto min-h-min w-full flex-col gap-3">
    <label v-if="getExeMatrixHideTitle" class="min-w-fit font-semibold leading-6">
      {{ getExeMatrixTitleName }}</label
    >

    <div
      :class="[
        'h-full  w-full gap-2 ',
        {
          'flex flex-col ': !getExeMatrixDisplay
        }
      ]"
    >
      <span v-show="!interActiveMode && showCPUAndMemory">
        CPU Time: <span class="font-semibold">{{ cpuTime }} sec(s) </span>
      </span>
      <span v-show="!interActiveMode && showCPUAndMemory && getExeMatrixDisplay"> | </span>
      <span v-show="!interActiveMode && showCPUAndMemory">
        Memory: <span class="font-semibold"> {{ memory }} kilobyte(s)</span>
      </span>
      <span
        v-show="
          !interActiveMode &&
          showCPUAndMemory &&
          isCompileLanguage &&
          showExecuteDetails &&
          getExeMatrixDisplay
        "
      >
        |
      </span>
      <span v-show="isCompileLanguage && showExecuteDetails">
        Compiled and executed in
        <span class="font-semibold">{{ executionTime }} sec(s)</span>
      </span>
    </div>
  </div>
</template>
